// 사용자 앱: 매장 운영설정 / 주소록 API 래퍼.

import type { AddressDto, AddressInput, AddressUpdate, StoreSettingsDto } from "@oo/shared";
import { api } from "@/api/client.ts";

// 공개 운영설정 (영업시간/배달 정책/예약 정책). 비로그인도 호출 가능.
export async function getStoreSettings(): Promise<StoreSettingsDto> {
  const data = await api.get<{ settings: StoreSettingsDto }>("/store-settings", {
    withAuth: false,
  });
  return data.settings;
}

// 내 배송지 목록.
export async function listAddresses(): Promise<AddressDto[]> {
  const data = await api.get<{ addresses: AddressDto[] }>("/me/addresses");
  return data.addresses;
}

// 배송지 추가.
export async function createAddress(input: AddressInput): Promise<AddressDto> {
  const data = await api.post<{ address: AddressDto }>("/me/addresses", input);
  return data.address;
}

// 배송지 수정.
export async function updateAddress(id: string, patch: AddressUpdate): Promise<AddressDto> {
  const data = await api.patch<{ address: AddressDto }>(`/me/addresses/${id}`, patch);
  return data.address;
}

// 배송지 삭제.
export async function deleteAddress(id: string): Promise<void> {
  await api.delete(`/me/addresses/${id}`);
}

// 기본 배송지 지정.
export async function setDefaultAddress(id: string): Promise<AddressDto> {
  const data = await api.post<{ address: AddressDto }>(`/me/addresses/${id}/default`);
  return data.address;
}
